export default __webpack_public_path__ + "static/media/crown-power-fencing-system-mettupalayam logo.17cfae7d.png";